import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import styled from "styled-components";
import detailImages from "../../assets/images/detailImages1.png";

import ButtonComponent from "../../components/ButtonComponent";
import { ArrowUpRight } from '@phosphor-icons/react';


const ProductDetailSectionSix = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <ProductDetailSectionSixStyled data-aos='fade-up' data-aos-duration='1500'>
      <div className='container'>
        <div className='bottom-container'>
          <div className='desc-container paragraph-large regular'>
            <div className='title display-small'>Lorem ipsum dolor sit.</div>
            <div className='desc paragraph-large regular'>
              <div className='desc-item'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.2891 9.14969 15.3718 9.09442 15.4628 9.0567C15.5539 9.01899 15.6515 8.99958 15.75 8.99958C15.8486 8.99958 15.9461 9.01899 16.0372 9.0567C16.1282 9.09442 16.2109 9.14969 16.2806 9.21937C16.3503 9.28906 16.4056 9.37178 16.4433 9.46283C16.481 9.55387 16.5004 9.65145 16.5004 9.75C16.5004 9.84855 16.481 9.94613 16.4433 10.0372C16.4056 10.1282 16.3503 10.2109 16.2806 10.2806Z'
                    fill='#09A557'
                  />
                </svg>
                <div>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Distinctio, nesciunt!
                </div>
              </div>
              <div className='desc-item'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.2891 9.14969 15.3718 9.09442 15.4628 9.0567C15.5539 9.01899 15.6515 8.99958 15.75 8.99958C15.8486 8.99958 15.9461 9.01899 16.0372 9.0567C16.1282 9.09442 16.2109 9.14969 16.2806 9.21937C16.3503 9.28906 16.4056 9.37178 16.4433 9.46283C16.481 9.55387 16.5004 9.65145 16.5004 9.75C16.5004 9.84855 16.481 9.94613 16.4433 10.0372C16.4056 10.1282 16.3503 10.2109 16.2806 10.2806Z'
                    fill='#09A557'
                  />
                </svg>
                <div>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Distinctio, nesciunt!
                </div>
              </div>
              <div className='desc-item'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.2891 9.14969 15.3718 9.09442 15.4628 9.0567C15.5539 9.01899 15.6515 8.99958 15.75 8.99958C15.8486 8.99958 15.9461 9.01899 16.0372 9.0567C16.1282 9.09442 16.2109 9.14969 16.2806 9.21937C16.3503 9.28906 16.4056 9.37178 16.4433 9.46283C16.481 9.55387 16.5004 9.65145 16.5004 9.75C16.5004 9.84855 16.481 9.94613 16.4433 10.0372C16.4056 10.1282 16.3503 10.2109 16.2806 10.2806Z'
                    fill='#09A557'
                  />
                </svg>
                <div>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Distinctio, nesciunt!
                </div>
              </div>
            </div>
            <div className='button-container'>
              <ButtonComponent
                text='Contact Us'
                icon={<ArrowUpRight size={32}/>}
                className='button outlined-primary border-radius-4 pointer paragraph-large'
              ></ButtonComponent>
            </div>
          </div>
          <div className='image-container'>
            <img
              data-aos='zoom-in'
              data-aos-duration='1500'
              data-aos-delay='750'
              src={detailImages}
              alt='culture'
            />
          </div>
        </div>
      </div>
    </ProductDetailSectionSixStyled>
  );
};

const ProductDetailSectionSixStyled = styled.div`
  padding: 80px 0px;
  background: var(--hxvr-neutral-40);
  .container {
    .bottom-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 72px;
      .desc-container {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 32px;
        .title {
          color: var(--hxvr-neutral-100);
        }
        .button-container {
          max-width: max-content;
        }

        .desc-item {
          display: flex;
          gap: 12px;
          align-items: start;
          color: var(--hxvr-neutral-secondary);
        }
      }
      .image-container {
        width: 50%;
        height: 666px;
        position: relatives;
        img {
          position: absolute;
          border-radius: 24px 0px 0px 0px;
          right: 0;
          height: 666px;
          width: 50%;
          object-position: center right;
          object-fit: fill;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .bottom-container {
      width: 100%;
      gap: 26px;
      .desc-container {
        width: 100% !important;
      }
      .image-container {
        display: none;
        width: 100%;
        height: 160px !important;
        img {
          height: 240px !important;
          width: 90% !important;
        }
      }
    }
  }

  @media (max-width: 992px) {
    .bottom-container {
      flex-direction: column !important;
      .desc-container {
        width: 100% !important;
      }
      .image-container {
        display: none;
      }
    }
  }
`;

export default ProductDetailSectionSix;
